import React from 'react';
import styles from './SiteFooter.module.css';

export default function SiteFooter() {
  return (
    <footer className={styles.footer}>
      <p>© {new Date().getFullYear()} Sergio W. Peterson</p>
      <p className={styles.cvNote}>
        Explore my CV projects at <a href="/cv/">/cv/</a> (under construction).
      </p>
      <p className={styles.credit}>Designed and built in San Francisco.</p>
    </footer>
  );
}
